import { render } from "./boat.vue?vue&type=template&id=0a2b9a0e"
import script from "./boat.vue?vue&type=script&lang=js"
export * from "./boat.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/pamenar-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__